import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const fetchProducts = async () => {
  const { data } = await client.get("/products");
  return data;
};

export const fetchProduct = async (id) => {
  const { data } = await client.get(`/products/${id}`);
  return data;
};

export const fetchTestimonials = async () => {
  const { data } = await client.get("/testimonials");
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await client.post("/newsletter", { email });
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await client.post("/contact", payload);
  return data;
};

export const fetchShippingRates = async ({ items, address }) => {
  const { data } = await client.post("/shipping/rates", { items, address });
  return data;
};

export const createCheckoutSession = async (payload) => {
  const { data } = await client.post("/checkout/session", payload);
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await client.get(`/checkout/status/${sessionId}`);
  return data;
};

export const validateCoupon = async ({ code, items, shipping_rate }) => {
  const { data } = await client.post("/payment/validate-coupon", {
    code,
    items,
    shipping_rate: shipping_rate || null,
  });
  return data;
};

export const createPaymentIntent = async ({
  items,
  customer_email,
  shipping_address,
  shipping_rate,
  promotion_code,
}) => {
  const { data } = await client.post("/payment/intent", {
    items,
    customer_email: customer_email || null,
    shipping_address: shipping_address || null,
    shipping_rate: shipping_rate || null,
    promotion_code: promotion_code || null,
  });
  return data;
};

export const createSubscription = async ({
  items,
  customer_email,
  shipping_address,
  shipping_rate,
}) => {
  const { data } = await client.post("/payment/subscription", {
    items,
    customer_email,
    shipping_address: shipping_address || null,
    shipping_rate: shipping_rate || null,
    promotion_code: null,
  });
  return data;
};

export const getPaymentIntentStatus = async (paymentIntentId) => {
  const { data } = await client.get(`/payment/intent/${paymentIntentId}`);
  return data;
};

export const trackOrder = async (params) => {
  const { data } = await client.get("/orders/track", { params });
  return data;
};

// ---------- Admin ----------
export const adminLoginExchange = async (sessionId) => {
  const { data } = await client.post("/auth/session", null, {
    headers: { "X-Session-ID": sessionId },
  });
  return data;
};

export const fetchAdminMe = async () => {
  const { data } = await client.get("/auth/me");
  return data;
};

export const adminLogout = async () => {
  await client.post("/auth/logout");
};

export const fetchAdminStats = async () => {
  const { data } = await client.get("/admin/stats");
  return data;
};

export const fetchAdminRevenue = async (params = {}) => {
  const { data } = await client.get("/admin/revenue", { params });
  return data;
};

export const fetchAdminOrders = async (params = {}) => {
  const { data } = await client.get("/admin/orders", { params });
  return data;
};

export const fetchAdminTopProducts = async () => {
  const { data } = await client.get("/admin/products/top");
  return data;
};

export const fetchAdminCoupons = async () => {
  const { data } = await client.get("/admin/coupons");
  return data;
};

export const fetchAdminNewsletter = async (params = {}) => {
  const { data } = await client.get("/admin/newsletter", { params });
  return data;
};

export const fetchAdminContacts = async (params = {}) => {
  const { data } = await client.get("/admin/contacts", { params });
  return data;
};

export const buyShippingLabel = async (orderId) => {
  const { data } = await client.post(`/admin/orders/${orderId}/buy-label`);
  return data;
};

export const adminOrdersExportUrl = `${BACKEND_URL}/api/admin/orders/export.csv`;
export const adminNewsletterExportUrl = `${BACKEND_URL}/api/admin/newsletter/export.csv`;
